export default __webpack_public_path__ + "static/img_welfare_7@2x-cff2175a82d443f766a594b8989b3c3d.jpg";